.field {
  display: inline;
}
